export default __webpack_public_path__ + "static/media/mobile_7.0d750f67.png";